import { apm } from "@elastic/apm-rum";
import { Box, Button, Fade, Modal, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";

interface BackToPlatformProps {
  showPlatformModal: boolean;
  handleClose: () => void;
  redirectToPlatform: () => void;
}

export default function BackToPlatformModal({
  showPlatformModal,
  handleClose,
  redirectToPlatform,
}: BackToPlatformProps) {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const { t } = useTranslation();

  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "left",
        height: "fit-content",
        padding: "10px 0px 0px 60px",
      }}
      open={showPlatformModal}
      onClose={handleClose}
    >
      <Fade in={showPlatformModal}>
        <Box
          sx={{
            overflow: "auto",
            position: "relative",
            backgroundColor: darkTheme ? "darkblue.main" : "white",
            borderRadius: "10px",
            padding: "16px",
          }}
        >
          {/* <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: { xs: "8px", lg: "24px" },
              right: { xs: "8px", lg: "24px" },
              color: darkTheme ? "white" : "darkblue.main",
              ":hover": { color: "secondary.main" },
            }}
          >
            <Close />
          </IconButton> */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexDirection: "row",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              component="h5"
              sx={{
                color: darkTheme ? "white" : "darkblue.main",
                width: "100%",
                textAlign: "left",
              }}
            >
              {t("back_to_platform.title")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexDirection: "row",
                marginLeft: 2,
              }}
            >
              <Button
                onClick={() =>
                  monitor(
                    apm,
                    "redirect-platform-yes | Logo",
                    redirectToPlatform
                  )
                }
                variant="contained"
                sx={{
                  backgroundColor: darkTheme ? "white" : "darkblue.main",
                  color: darkTheme ? "darkblue.main" : "white",
                  "@media (hover: hover)": {
                    ":hover": {
                      backgroundColor: darkTheme ? "white" : "darkblue.main",
                      color: "secondary.main",
                    },
                  },
                }}
              >
                {t("back_to_platform.button_yes")}
              </Button>
              <Button
                onClick={() =>
                  monitor(apm, "redirect-platform-no | Logo", handleClose)
                }
                variant="contained"
                sx={{
                  backgroundColor: darkTheme ? "white" : "darkblue.main",
                  color: darkTheme ? "darkblue.main" : "white",
                  "@media (hover: hover)": {
                    ":hover": {
                      backgroundColor: darkTheme ? "white" : "darkblue.main",
                      color: "secondary.main",
                    },
                  },
                }}
              >
                {t("back_to_platform.button_no")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
